import type { QueryClient } from "@tanstack/react-query";
import type { FilterDoubt } from "@oneapp/data";
import {
  getDc1AvailableFreeDoubts,
  getGetDc1AvailableFreeDoubtsQueryKey,
  postDc1UserGetDoubtsv2,
} from "@oneapp/data";

const doubtsAiRequest = { clientName: "doubtsAi" as const };

/**
 * After autosolve, match reference app: refresh free-doubt quota and my-doubts list on doubtsai.
 */
export async function refreshDoubtsAiAfterSessionClose(
  queryClient: QueryClient,
  params: {
    userId: number;
    /** DC tenant key (may be UUID) for list/filter APIs. */
    tenantId: string;
    /** Numeric tenant for `GET .../availableFreeDoubts` (server expects Long). */
    dcNumericTenantId: string | null;
    gradeId: number | null;
  },
): Promise<void> {
  const { userId, tenantId, dcNumericTenantId, gradeId } = params;

  if (dcNumericTenantId) {
    const freeParams = {
      userId: String(userId),
      tenantId: dcNumericTenantId,
    };
    await queryClient.fetchQuery({
      queryKey: getGetDc1AvailableFreeDoubtsQueryKey(freeParams),
      queryFn: ({ signal }) =>
        getDc1AvailableFreeDoubts(freeParams, doubtsAiRequest, signal),
    });
  }

  const body: FilterDoubt = {
    userId,
    page: 1,
    subjectIds: [],
    status: [],
    startDate: null,
    endDate: null,
    tenantId,
    ...(gradeId != null ? { gradeId } : {}),
  };

  await postDc1UserGetDoubtsv2(body, doubtsAiRequest);

  await queryClient.invalidateQueries({
    queryKey: ["postDc1UserGetDoubtsv2"],
  });
}
